import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {SETTINGS} from "../config/common.settings";

@Injectable({
  providedIn: 'root'
})
export class WordReportService {

  constructor(private http: HttpClient) { }


  generateWordReport(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/word/generate`, data, {
          responseType: 'blob',
          headers: { Accept: 'application/pdf' },
        })
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  downloadDocxReport(data: Response | any, filename: string): any {
    const blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = `${filename}.docx`; // file name
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }
}
